import React from 'react';
import './Policy.css';

const TermsAndConditions = () => {
  return (
    <div className="policy-page">
      <div className="container padding">
        <div className="heading">
          <h2>Terms & Conditions</h2>
        </div>
        <div className="policy-content">
          <div className="policy-intro">
            <p>
              This document is an electronic record in terms of the Information Technology Act, 2000, and rules thereunder 
              as applicable, and the amended provisions pertaining to electronic records in various statutes as amended by 
              the Information Technology Act, 2000. This electronic record is generated by a computer system and does not 
              require any physical or digital signatures.
            </p>
            <p>
              This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology 
              (Intermediaries guidelines) Rules, 2011, that require publishing the rules and regulations, privacy policy, 
              and Terms of Use for access or usage of the domain name nqa1.in ("Website"), including the related mobile site 
              and mobile application (hereinafter referred to as "Platform").
            </p>
            <p>
              The Platform is owned by NURTURE QUEST ASSOCIATION, a company incorporated under the Companies Act, 1956, with 
              its registered office at PLOT NO 1759, KALIGANJ, PO-ARRAH, BIDHANNAGAR, DURGAPUR MC BARDHAMAN WEST BENGAL 713212 
              India (hereinafter referred to as "Platform Owner," "we," "us," or "our").
            </p>
          </div>

          <div className="policy-notice-box">
            <p>
              <strong>ACCESSING, BROWSING, OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND 
              CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THEM CAREFULLY BEFORE PROCEEDING.</strong>
            </p>
          </div>

          <div className="terms-list">
            <div className="policy-section">
              <h3>1. Accuracy of Information</h3>
              <p>
                To access and use the Services, you agree to provide true, accurate, and complete information to us during and 
                after registration, and you shall be responsible for all acts done through the use of your registered account on 
                the Platform.
              </p>
            </div>

            <div className="policy-section">
              <h3>2. No Warranty</h3>
              <p>
                Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, 
                completeness, or suitability of the information and materials offered on this website or through the Services for 
                any specific purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and 
                we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
              </p>
            </div>

            <div className="policy-section">
              <h3>3. At Your Own Risk</h3>
              <p>
                Your use of our Services and the Platform is solely and entirely at your own risk and discretion, for which we 
                shall not be liable to you in any manner. You are required to independently assess and ensure that the Services 
                meet your requirements.
              </p>
            </div>

            <div className="policy-section">
              <h3>4. Intellectual Property</h3>
              <p>
                The contents of the Platform and the Services are proprietary to us and licensed to us. You will not have any 
                authority to claim any intellectual property rights, title, or interest in its contents. The content includes, 
                but is not limited to, the design, layout, look, and graphics.
              </p>
            </div>

            <div className="policy-section">
              <h3>5. Unauthorized Use</h3>
              <p>
                You acknowledge that unauthorized use of the Platform and/or the Services may lead to action against you as per 
                these Terms of Use and/or applicable laws.
              </p>
            </div>

            <div className="policy-section">
              <h3>6. Service Charges</h3>
              <p>You agree to pay us the charges associated with availing the Services.</p>
            </div>

            <div className="policy-section">
              <h3>7. Lawful Use</h3>
              <p>
                You agree not to use the Platform and/or Services for any purpose that is unlawful, illegal, or forbidden by these 
                Terms, or by Indian or local laws that might apply to you.
              </p>
            </div>

            <div className="policy-section">
              <h3>8. Third-Party Links</h3>
              <p>
                You acknowledge that the website and Services may contain links to third-party websites. Upon accessing these links, 
                you will be governed by the terms of use, privacy policy, and other policies of such third-party websites. These 
                links are provided for your convenience to provide further information.
              </p>
            </div>

            <div className="policy-section">
              <h3>9. Legally Binding Contract</h3>
              <p>
                You understand that upon initiating a transaction for availing the Services, you are entering into a legally binding 
                and enforceable contract with the Platform Owner for the Services.
              </p>
            </div>

            <div className="policy-section">
              <h3>10. Indemnity</h3>
              <p>
                You shall indemnify and hold harmless the Platform Owner, its affiliates, group companies (as applicable), and their 
                respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable 
                attorneys' fees, made by any third party or penalty imposed due to or arising out of your breach of these Terms 
                of Use, Privacy Policy, and other Policies, or your violation of any law, rules, or regulations or the rights 
                (including infringement of intellectual property rights) of a third party.
              </p>
            </div>

            <div className="policy-section">
              <h3>11. Limitation of Liability</h3>
              <p>
                In no event will the Platform Owner be liable for any indirect, consequential, incidental, special, or punitive 
                damages, including without limitation, damages for loss of profits or revenues, business interruption, loss of business 
                opportunities, loss of data, or loss of other economic interests, whether in contract, negligence, tort, or otherwise, 
                arising from the use of or inability to use the Services. However, the Platform Owner's liability will not exceed the 
                amount paid by you for using the Services giving rise to the cause of action or Rupees One Hundred (Rs. 100), whichever 
                is less.
              </p>
            </div>

            <div className="policy-section">
              <h3>12. Force Majeure</h3>
              <p>
                Notwithstanding anything contained in these Terms of Use, the parties shall not be liable for any failure to perform 
                an obligation under these Terms if performance is prevented or delayed by a force majeure event.
              </p>
            </div>

            <div className="policy-section">
              <h3>13. Governing Law and Jurisdiction</h3>
              <p>
                These Terms and any dispute or claim relating to them, or their enforceability, shall be governed by and construed in 
                accordance with the laws of India. All disputes arising out of or in connection with these Terms shall be subject to 
                the exclusive jurisdiction of the courts in BARDHAMAN, WEST BENGAL.
              </p>
            </div>

            <div className="policy-section">
              <h3>14. Contact Information</h3>
              <p>
                All concerns or communications relating to these Terms must be communicated to us using the contact information 
                provided on this website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

